if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();

        if (document.body.hasAttribute("swiper-loaded")) {
          this.initSliders();
        } else {
          document.addEventListener('swiper-loaded', (event) => {
            this.initSliders();
          });
        }
      }

      initObjects() {
        this.elements = {
          gallerySliderMobile: this.querySelector('[id^="GallerySlider_Mobile"] .swiper'),
          gallerySliderMobilePagination: this.querySelector('[id^="GallerySlider_Mobile"] .swiper-pagination'),
          gallerySliderDesktop: this.querySelector('[id^="GallerySlider_Desktop"] .swiper'),
          galleryThumbnailsDesktop: this.querySelector('[id^="GalleryThumbnails_Desktop"] .swiper'),
          galleryThumbnailsDesktopPrev: this.querySelector('[id^="GalleryThumbnails_Desktop"] .swiper-button-prev__custom'),
          galleryThumbnailsDesktopNext: this.querySelector('[id^="GalleryThumbnails_Desktop"] .swiper-button-next__custom')
        };
      }

      initSliders() {
        this.initObjects();

        if (window.matchMedia("(max-width: 767px)").matches) {
          this.gallerySliderMobileSwiper = new Swiper(this.elements.gallerySliderMobile, {
            slidesPerView: 1.3,
            spaceBetween: 0,
            preventClicks: false,
            preventClicksPropagation: false,
            pagination: {
              el: this.elements.gallerySliderMobilePagination,
              clickable: true,
              dynamicBullets: true,
              dynamicMainBullets: 6
            },
            on: {
              init: (slider) => {
                const simpleActiveInput = document.querySelector(".template-suffix-simple .input-color-js.active");

                if (simpleActiveInput) {
                  const totalProductImages = document.querySelectorAll(".template-suffix-simple #GalleryThumbnails_Desktop .product-image").length;
                  const elementPosition = parseInt(simpleActiveInput.dataset.position) + parseInt(totalProductImages);

                  slider.slideTo(elementPosition);
                }
              }
            }
          });
        } else if (window.matchMedia("(min-width: 768px)").matches) {
          this.galleryThumbnailsDesktopSwiper = new Swiper(this.elements.galleryThumbnailsDesktop, {
            slidesPerView: this.elements.gallerySliderDesktop.parentElement.classList.contains('simple') ? 6 : 3,
            spaceBetween: this.elements.gallerySliderDesktop.parentElement.classList.contains('simple') ? 0 : 10,
            direction: 'vertical',
            allowTouchMove: false,
            preventClicks: false,
            preventClicksPropagation: false,
            autoHeight: true,
            navigation: {
              nextEl: this.elements.galleryThumbnailsDesktopNext,
              prevEl: this.elements.galleryThumbnailsDesktopPrev
            },
            on: {
              init: (slider) => {
                const simpleActiveInput = document.querySelector(".template-suffix-simple .input-color-js.active");

                if (simpleActiveInput) {
                  const totalProductImages = document.querySelectorAll(".template-suffix-simple #GalleryThumbnails_Desktop .product-image").length;
                  const elementPosition = parseInt(simpleActiveInput.dataset.position) + parseInt(totalProductImages);

                  slider.slideTo(elementPosition);
                }
              }
            }
          });
  
          this.gallerySliderDesktopSwiper = new Swiper(this.elements.gallerySliderDesktop, {
            slidesPerView: this.elements.gallerySliderDesktop.parentElement.classList.contains('simple') ? 1 : 2,
            spaceBetween: 20,
            direction: this.elements.gallerySliderDesktop.parentElement.classList.contains('simple') ? 'horizontal': 'vertical',
            allowTouchMove: false,
            preventClicks: false,
            preventClicksPropagation: false,
            thumbs: {
              swiper: this.galleryThumbnailsDesktopSwiper
            },
            on: {
              init: (slider) => {
                const simpleActiveInput = document.querySelector(".template-suffix-simple .input-color-js.active");

                if (simpleActiveInput) {
                  const totalProductImages = document.querySelectorAll(".template-suffix-simple #GalleryThumbnails_Desktop .product-image").length;
                  const elementPosition = parseInt(simpleActiveInput.dataset.position) + parseInt(totalProductImages);

                  slider.slideTo(elementPosition);
                }
              }
            }
          });
  
          this.galleryThumbnailsDesktopSwiper
            .on('click', (swiper) => {
              const selectedVariantElement = document.querySelector("#GalleryThumbnails_Desktop .selected-variant-container")
              let positionToSlide = swiper.clickedIndex;

              if (selectedVariantElement && selectedVariantElement.classList.contains("d-none")) {
                positionToSlide = positionToSlide - 1;
              }

              if (swiper.clickedSlide.innerHTML == "") {
                positionToSlide = positionToSlide - 2;
              }

              this.galleryThumbnailsDesktopSwiper.slideTo(positionToSlide);
              this.gallerySliderDesktopSwiper.slideTo(positionToSlide);
            })
            .on('slidePrevTransitionStart', () => {
              this.gallerySliderDesktopSwiper.slidePrev();
            })
            .on('slideNextTransitionStart', () => {
              this.gallerySliderDesktopSwiper.slideNext();
            })
          ;
        }

        document.addEventListener("click", e => {
          let simpleImageButton; 

          if (document.body.classList.contains("template-suffix-simple-reverse-gallery")) {
            simpleImageButton = e.target.closest(".template-suffix-simple-reverse-gallery .btn-color-js");
          } else {
            simpleImageButton = e.target.closest(".template-suffix-simple .btn-color-js");
          }
          
          if (simpleImageButton) {
            let firstImageElement;
            let elementPosition;

            if (document.body.classList.contains("template-suffix-simple-reverse-gallery")) {
              firstImageElement = document.querySelector(`.product-media-container[data-image-label="${simpleImageButton.title}"]`);
              elementPosition = parseInt(firstImageElement.dataset.imagePosition);
            } else {
              const totalProductImages = document.querySelectorAll(".template-suffix-simple #GalleryThumbnails_Desktop .product-image").length;
              elementPosition = parseInt(simpleImageButton.dataset.position) + parseInt(totalProductImages);
            }

            if (window.matchMedia("(min-width: 768px)").matches) {
              this.galleryThumbnailsDesktopSwiper.slideTo(elementPosition);
              this.gallerySliderDesktopSwiper.slideTo(elementPosition);
            } else {
              this.gallerySliderMobileSwiper.slideTo(elementPosition);
            }
          }
        });
      }

      get getGallerySliderMobileSwiper() {
        return this.gallerySliderMobileSwiper;
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`);
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia.classList.add('is-active');

        if (prepend) {
          activeMedia.parentElement.prepend(activeMedia);
          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.prepend(activeThumbnail);
          }
          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
            activeMedia.scrollIntoView({ behavior: 'smooth' });
          }
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}
